import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector, useDispatch } from "react-redux";
import { getAllCohorts, cohortSelector, changeCohortStatus, setSelectedStatus, resetCohort, setCustomText, getCohort, isStudentSubmissionExistForCohort, } from "./CohortSlice";
import { format } from "date-fns";
import { timelineSelector } from "../licensurePlans/TimelineSlice";
import { useIntl } from "react-intl";
import { generateUTCDate, getI18nValueByKey, } from "../common/commonActions";
import { getValueByKey } from "../common/commonActions";
import { WmSelect, WmOption, WmSearch, } from "@watermarkinsights/ripple-react";
import translate from "../../i18n/translate";
import { cohortStatus } from "./data/CohortStatus";
import { cohortStatusFilterData } from "./data/CohortStatusFilter";
import { cohortTimelineStatus } from "./data/CohortTimelineStatus";
import "./Cohorts.scss";
import { useEffect, useState } from "react";
import ViewCohort from "../cohorts/ViewCohort";
import { focusButtonComponent, closeFlyout, } from "../../static/js/commons";
import { ariaAlertResults } from "./OpenRequirement";
import DiscardModal from "../common/component/DiscardWmModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../../features/common/component/Loading";
export default function CohortCards(props) {
    var _a, _b;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    let { programUuid } = useParams();
    const { cohortList, currentCohortUuid, planStatusFilter, cohortStatusFilter, selectedStatus, statusCounter, unpublishCounter, filteredIndex, isFetchingCohorts, isFetchingCohort, isFetching, customText, isFetchingRequirementData, } = useSelector(cohortSelector);
    const { timelineData, currentProgramData, isFetchingTimeline } = useSelector(timelineSelector);
    const [showCohortFlyout, setCohortFlyout] = useState(false);
    document.title = props.programTitle + " | Watermark";
    const [selectedCohortStatus, setSelectedCohortStatus] = useState("ACTIVE");
    const [statusFilter, setStatusFilter] = useState([]);
    const [currentCohort, setCurrentCohort] = useState({
        title: "",
        uuid: "",
        users: [],
        cohortTimeline: {
            uuid: "",
            status: "",
            releaseDate: "",
            updatedAt: "",
            sendNotification: false,
            timelineUuid: "",
            formattedReleaseDate: "",
        },
    });
    let filterValues = (_a = location.state) === null || _a === void 0 ? void 0 : _a.filterValues;
    let [searchText, setSearchText] = useState(filterValues ? filterValues.searchText : "");
    let [renderFilteredCohorts, setRenderFilteredCohorts] = useState(cohortList);
    const [openDiscardModal, setOpenDiscardModal] = useState(false);
    const [cohortData, setCohortData] = useState();
    const discardModalArchiveHeading = useIntl().formatMessage({
        id: "app.cohort.discardModal.archived.heading",
    });
    const discardModalArchiveContent = useIntl().formatMessage({
        id: "app.cohort.discardModal.archived.content",
    });
    const discardModalRestoreHeading = useIntl().formatMessage({
        id: "app.cohort.discardModal.restore.heading",
    });
    const discardModalRestoreContent = useIntl().formatMessage({
        id: "app.cohort.discardModal.restore.content",
    });
    const discardModalAriaLabelValue = useIntl().formatMessage({
        id: "app.cohort.discardModal.ariaLabelValue",
    });
    const discardModalPrimaryTextArchive = useIntl().formatMessage({
        id: "app.cohort.discardModal.primaryText.archive",
    });
    const discardModalPrimaryTextRestore = useIntl().formatMessage({
        id: "app.cohort.discardModal.primaryText.restore",
    });
    const discardModalSecondaryText = useIntl().formatMessage({
        id: "app.cohort.discardModal.secondaryText",
    });
    useEffect(() => {
        if (props.orgUuid !== undefined && props.programUuid !== undefined) {
            dispatch(getAllCohorts({
                orgUuid: props.orgUuid,
                programUuid: props.programUuid,
            }));
        }
        dispatch(setSelectedStatus(filterValues && filterValues.selectedStatus
            ? filterValues.selectedStatus
            : "ALL"));
        setSelectedCohortStatus(filterValues && filterValues.selectedCohortStatus
            ? filterValues.selectedCohortStatus
            : "ACTIVE");
        setStatusFilter(Array.from(new Set(planStatusFilter.map((status) => {
            return status == "PUBLISHED" ? status : "UNPUBLISHED";
        }))));
        return () => {
            dispatch(resetCohort());
        };
    }, []);
    useEffect(() => {
        setStatusFilter(Array.from(new Set(planStatusFilter.map((status) => {
            return status == "PUBLISHED" ? status : "UNPUBLISHED";
        }))));
    }, [planStatusFilter]);
    useEffect(() => {
        var _a;
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.currentCohortUuid) {
            setTimeout(() => {
                var _a;
                const cohortLink = document.getElementById("program-button-id" + ((_a = location.state) === null || _a === void 0 ? void 0 : _a.currentCohortUuid));
                cohortLink === null || cohortLink === void 0 ? void 0 : cohortLink.focus();
            }, 100);
        }
        if (props.publishingCohortUuid && props.publishingCohortUuid !== "") {
            const cohortEl = document.getElementById("program-button-id" + props.publishingCohortUuid);
            cohortEl === null || cohortEl === void 0 ? void 0 : cohortEl.focus();
        }
    }, [isFetchingCohorts]);
    useEffect(() => {
        if (unpublishCounter !== null &&
            unpublishCounter < 0 &&
            selectedStatus === "ALL") {
            focusButtonComponent("status-update-" + currentCohortUuid);
        }
        if (unpublishCounter !== null && unpublishCounter > 0) {
            const filteredCohortList = cohortList.filter((coh) => coh.cohortTimeline ? false : true);
            if (filteredIndex !== -1 &&
                filteredCohortList.length > 0 &&
                selectedStatus !== "ALL") {
                if (filteredIndex === filteredCohortList.length) {
                    focusButtonComponent("publish-button-" + filteredCohortList[filteredIndex - 1].uuid);
                }
                else {
                    focusButtonComponent("publish-button-" + filteredCohortList[filteredIndex].uuid);
                }
            }
        }
        if (unpublishCounter !== null && unpublishCounter === 0) {
            focusButtonComponent("status-update-" + cohortList[0].uuid);
        }
    }, [unpublishCounter]);
    useEffect(() => {
        if (!showCohortFlyout) {
            closeFlyout();
            const cohortEl = document.getElementById("program-button-id" + currentCohort.uuid);
            cohortEl === null || cohortEl === void 0 ? void 0 : cohortEl.focus();
        }
    }, [showCohortFlyout]);
    useEffect(() => {
        if (statusCounter !== null && statusCounter > 0) {
            const filteredCohortList = cohortList.filter((coh) => coh.cohortTimeline ? coh.cohortTimeline.status == selectedStatus : false);
            if (filteredIndex !== -1 && filteredCohortList.length > 0) {
                if (filteredIndex === filteredCohortList.length) {
                    focusButtonComponent("status-update-" + filteredCohortList[filteredIndex - 1].uuid);
                }
                else {
                    focusButtonComponent("status-update-" + filteredCohortList[filteredIndex].uuid);
                }
            }
        }
        if (statusCounter !== null && statusCounter === 0) {
            focusButtonComponent("status-update-" + cohortList[0].uuid);
        }
    }, [statusCounter]);
    const searchTextHandler = (event) => {
        event.preventDefault();
        setSearchText(event.target.value);
    };
    const cohortClickHandler = (event, currentCohort) => {
        event.preventDefault();
        dispatch(getCohort({
            orgUuid: props.orgUuid,
            programUuid: programUuid,
            cohortUuid: currentCohort.uuid,
        })).then(() => dispatch(isStudentSubmissionExistForCohort({ cohortUuid: currentCohort.uuid })).then(() => {
            navigate({
                pathname: "/cohort/" + currentCohort.uuid,
            }, {
                state: {
                    currentCohort,
                    currentProgramData: currentProgramData,
                    timelineUuid: timelineData.uuid,
                    programUuid: programUuid,
                    filterValues: {
                        searchText,
                        selectedStatus,
                        selectedCohortStatus,
                    },
                },
            });
            focusButtonComponent("go-back");
        }));
    };
    const closeFlyoutHandler = (event) => {
        event.preventDefault();
        setCohortFlyout(false);
    };
    const updateFilterHandler = (event, status) => {
        event.preventDefault();
        dispatch(setSelectedStatus(status));
        dispatch(setCustomText(getValueByKey(status, cohortTimelineStatus)));
    };
    const changeStatusHandler = (cohort) => {
        setCohortData(cohort);
        setOpenDiscardModal(true);
    };
    const changeStatus = (event) => {
        dispatch(changeCohortStatus({
            organizationUuid: props.organizationUuid,
            programUuid: props.programUuid,
            cohortUuid: cohortData === null || cohortData === void 0 ? void 0 : cohortData.uuid,
            cohortTimelineUuid: cohortData === null || cohortData === void 0 ? void 0 : cohortData.cohortTimeline.uuid,
            status: (cohortData === null || cohortData === void 0 ? void 0 : cohortData.cohortTimeline.status) === "PUBLISHED"
                ? "ARCHIVED"
                : "PUBLISHED",
        }));
        setOpenDiscardModal(false);
    };
    const closeDiscardModalHandler = (event) => {
        event.preventDefault();
        setOpenDiscardModal(false);
    };
    const getFilteredCohortsByCohortStatus = (cohortList) => {
        return cohortList.filter((cohortData) => {
            if (selectedCohortStatus === "ALL") {
                return true;
            }
            else {
                return cohortData.status === selectedCohortStatus;
            }
        });
    };
    const getFilteredCohorts = (cohortList) => {
        return cohortList.filter((cohortData) => {
            var _a, _b;
            if (selectedStatus === "ALL") {
                return true;
            }
            else if (selectedStatus === "UNPUBLISHED") {
                return (!cohortData.cohortTimeline ||
                    ((_a = cohortData.cohortTimeline) === null || _a === void 0 ? void 0 : _a.status) === "SCHEDULED" ||
                    ((_b = cohortData.cohortTimeline) === null || _b === void 0 ? void 0 : _b.status) === "ARCHIVED");
            }
            else {
                return cohortData.cohortTimeline
                    ? selectedStatus === cohortData.cohortTimeline.status
                    : false;
            }
        });
    };
    const updatedCohortList = (tempCohortList) => {
        return getFilteredCohortsByCohortStatus(getFilteredCohorts(tempCohortList)).sort();
    };
    const mappedCohortData = (tempCohortList) => {
        return tempCohortList.map((cohort) => {
            var _a, _b, _c, _d, _e;
            return (_jsxs("div", Object.assign({ className: "wm-grid-col-4 wm-grid-col-lg-6 wm-grid-xl-4 wm-grid-col-md-6 wm-grid-sm-8 wm-grid-col-xs-9 cohort-card" }, { children: [_jsxs("div", Object.assign({ className: "paper-card program-card -cohort-card" }, { children: [_jsx("div", Object.assign({ className: "plan-title overflow-title prog-titles", title: props.programTitle }, { children: props.programTitle })), _jsx("div", Object.assign({ className: "cohort-header flex-row -justified -verticallycentered" }, { children: _jsx("a", Object.assign({ href: "#", id: "program-button-id" + cohort.uuid, className: "cohort-name program-link", onClick: (event) => cohortClickHandler(event, cohort) }, { children: cohort.title })) })), _jsxs("div", Object.assign({ className: "cohort-contents" }, { children: [_jsxs("div", Object.assign({ className: "field-data" }, { children: [_jsxs("div", Object.assign({ className: "textfieldlabel" }, { children: [translate("app.cohort.entryTerm"), ":", " "] })), _jsx("div", Object.assign({ className: "textfieldvalue" }, { children: cohort.entryTermObject.name }))] })), cohort.projectedEndTermObject ? (_jsxs("div", Object.assign({ className: "field-data" }, { children: [_jsxs("div", Object.assign({ className: "textfieldlabel" }, { children: [translate("app.cohort.projectedEndTerm"), ":", " "] })), _jsxs("div", Object.assign({ className: "textfieldvalue" }, { children: [" ", cohort.projectedEndTermObject.name] }))] }))) : (""), _jsxs("div", Object.assign({ className: "field-data" }, { children: [_jsxs("div", Object.assign({ className: "textfieldlabel" }, { children: [translate("app.cohort.status"), ":", " "] })), _jsxs("div", Object.assign({ className: "textfieldvalue" }, { children: [" ", getI18nValueByKey(cohort.status, cohortStatus)] }))] })), cohort.cohortTimeline == null ? ("") : ((_a = cohort.cohortTimeline) === null || _a === void 0 ? void 0 : _a.status) == "ARCHIVED" ? (_jsxs("div", Object.assign({ className: "field-data" }, { children: [_jsxs("div", Object.assign({ className: "textfieldlabel" }, { children: [translate("app.cohort.dateArchived"), ":", " "] })), _jsxs("div", Object.assign({ className: "textfieldvalue" }, { children: [" ", format(generateUTCDate(new Date((_b = cohort.cohortTimeline) === null || _b === void 0 ? void 0 : _b.updatedAt)), "MM/dd/yyyy")] }))] }))) : (_jsxs("div", Object.assign({ className: "field-data" }, { children: [_jsxs("div", Object.assign({ className: "textfieldlabel" }, { children: [translate("app.cohort.releaseDate"), ":", " "] })), _jsx("div", Object.assign({ className: "textfieldvalue" }, { children: (_c = cohort.cohortTimeline) === null || _c === void 0 ? void 0 : _c.formattedReleaseDate }))] })))] })), _jsx("div", Object.assign({ className: ((_d = cohort.cohortTimeline) === null || _d === void 0 ? void 0 : _d.timelineUuid)
                                    ? "plan-published"
                                    : "plan-scheduled" }, { children: ((_e = cohort.cohortTimeline) === null || _e === void 0 ? void 0 : _e.timelineUuid)
                                    ? translate("app.cohort.connectedToPlan")
                                    : translate("app.cohort.NotConnectedToPlan") }))] })), _jsx(DiscardModal, { isOpen: openDiscardModal, onPrimaryClick: (event) => changeStatus(event), onSecondaryClick: (event) => closeDiscardModalHandler(event), onClose: (event) => closeDiscardModalHandler(event), modalContent: (cohortData === null || cohortData === void 0 ? void 0 : cohortData.cohortTimeline.status) == "ARCHIVED"
                            ? discardModalRestoreContent
                            : discardModalArchiveContent, modalHeading: (cohortData === null || cohortData === void 0 ? void 0 : cohortData.cohortTimeline.status) == "ARCHIVED"
                            ? discardModalRestoreHeading
                            : discardModalArchiveHeading, ariaLabelValue: discardModalAriaLabelValue, modalId: "archive-modal-" + cohort.uuid, contentId: "content-archive-modal-" + cohort.uuid, primaryText: (cohortData === null || cohortData === void 0 ? void 0 : cohortData.cohortTimeline.status) == "ARCHIVED"
                            ? discardModalPrimaryTextRestore
                            : discardModalPrimaryTextArchive, secondayText: discardModalSecondaryText })] }), "program" + cohort.uuid));
        });
    };
    const cohortCards = (_jsx("div", { children: _jsx("div", { children: renderFilteredCohorts &&
                updatedCohortList(renderFilteredCohorts).length ? (_jsx("div", Object.assign({ className: "active-cohorts" }, { children: _jsx("div", Object.assign({ className: "wm-grid" }, { children: _jsx("div", Object.assign({ className: "wm-grid-row" }, { children: mappedCohortData(updatedCohortList(renderFilteredCohorts)) })) })) }))) : null }) }));
    useEffect(() => {
        if (cohortStatusFilter && cohortStatusFilter.length > 0) {
            if (cohortStatusFilter.indexOf("ACTIVE") === -1) {
                setSelectedCohortStatus("ALL");
            }
        }
    }, [cohortStatusFilter]);
    useEffect(() => {
        if (searchText !== "") {
            setRenderFilteredCohorts(getSearchedCohorts(getFilteredCohortsByCohortStatus(getFilteredCohorts(cohortList)), searchText));
        }
        else
            setRenderFilteredCohorts(getFilteredCohortsByCohortStatus(getFilteredCohorts(cohortList)));
    }, [cohortList, searchText, selectedStatus, selectedCohortStatus]);
    const getSearchedCohorts = (cohorts, searchText) => {
        return cohorts.filter((c) => {
            return c.title.toLowerCase().includes(searchText.toLowerCase());
        });
    };
    const renderEmptyView = () => {
        return (_jsxs("div", Object.assign({ className: "empty-cohort-view" }, { children: [_jsx("div", Object.assign({ className: "no-students-label" }, { children: translate("app.gatewaysLandingPage.noMatch") })), _jsx("div", Object.assign({ className: "no-students-info" }, { children: translate("app.gatewaysLandingPage.adjustAndTryAgain") }))] })));
    };
    let searchPlaceholdler = useIntl().formatMessage({
        id: "app.cohort.search.placeholder",
    });
    let cohortStatusLabel = useIntl().formatMessage({
        id: "app.cohort.dropdown.cohortstatus.label",
    });
    let planStatusLabel = useIntl().formatMessage({
        id: "app.cohort.dropdown.planstatus.label",
    });
    let notConnectedText = useIntl().formatMessage({
        id: "app.cohortTimelineStatus.not.connected",
    });
    return isFetchingCohorts ||
        isFetchingTimeline ||
        isFetchingRequirementData ? (_jsx(Loading, {})) : (_jsxs("div", Object.assign({ className: "cohort-sub-tab" }, { children: [cohortList.length ? (_jsxs(_Fragment, { children: [_jsx("h2", Object.assign({ className: "cohort-label" }, { children: translate("app.cohort.cohorts") })), _jsxs("div", Object.assign({ className: "flex-row -verticallycentered -justified " }, { children: [_jsx("div", Object.assign({ className: "-search-bar" }, { children: _jsx(WmSearch, { id: "search-student", class: "student-search", placeholder: searchPlaceholdler, label: searchPlaceholdler, onInput: (event) => searchTextHandler(event), numResults: renderFilteredCohorts.length, value: searchText }) })), _jsxs("div", Object.assign({ className: "filter-plan-status flex-row -verticallycentered" }, { children: [_jsx("span", Object.assign({ className: "filter-label" }, { children: translate("app.cohort.filterBy") })), _jsx("div", Object.assign({ className: "select-status -filter-by" }, { children: _jsxs(WmSelect, Object.assign({ label: cohortStatusLabel, labelPosition: "none", id: "filter-cohort-status", placeholder: undefined }, { children: [_jsx(WmOption, Object.assign({ "aria-label": "All", selected: selectedCohortStatus === "ALL", onWmOptionSelected: (event) => setSelectedCohortStatus("ALL"), placeholder: undefined }, { children: translate("app.cohortTimelineStatus.all") })), cohortStatusFilter.map((status) => (_jsx(WmOption, Object.assign({ "aria-label": getI18nValueByKey(status, cohortStatusFilterData), onWmOptionSelected: (event) => setSelectedCohortStatus(status), selected: selectedCohortStatus === status, placeholder: undefined }, { children: getI18nValueByKey(status, cohortStatusFilterData) }), "option" + status)))] }), "select-" + cohortStatusFilter) })), _jsx("div", Object.assign({ className: "select-status" }, { children: _jsxs(WmSelect, Object.assign({ label: planStatusLabel, labelPosition: "none", id: "filter-plan-status", placeholder: undefined }, { children: [_jsx(WmOption, Object.assign({ "aria-label": "All", selected: selectedStatus === "ALL", onWmOptionSelected: (event) => updateFilterHandler(event, "ALL"), placeholder: undefined }, { children: translate("app.cohortTimelineStatus.filter.all") })), statusFilter.map((status) => (_jsx(WmOption, Object.assign({ "aria-label": getValueByKey(status, cohortTimelineStatus), onWmOptionSelected: (event) => updateFilterHandler(event, status), selected: selectedStatus === status, placeholder: undefined }, { children: status === "PUBLISHED" || status === "UNPUBLISHED"
                                                        ? getValueByKey(status, cohortTimelineStatus)
                                                        : notConnectedText }), "option" + status)))] }), "select-" + statusFilter) }))] }))] })), renderFilteredCohorts.length > 0 ? (_jsx("div", Object.assign({ className: "plans-progress cohort-cards" }, { children: cohortCards }))) : (renderEmptyView())] })) : (_jsxs("div", Object.assign({ className: "no-cohorts-connected" }, { children: [_jsx("span", { className: "mdi mdi-alert-circle" }), _jsx("div", Object.assign({ className: "empty-state-header" }, { children: translate("app.cohort.noCohortsConnected") })), _jsx("p", Object.assign({ className: "empty-state-content" }, { children: translate("app.cohort.noCohortsConnectedText") })), _jsx("p", Object.assign({ className: "empty-state-content" }, { children: translate("app.cohort.contactAdiminstratorText") }))] }))), _jsx("div", { className: "sr-only", id: "dialog-wrapper-top", tabIndex: 0 }), showCohortFlyout ? (_jsx(ViewCohort, { programTitle: props.programTitle, cohortData: currentCohort, closeViewCohort: closeFlyoutHandler })) : null, ariaAlertResults(cohortList === null || cohortList === void 0 ? void 0 : cohortList.length, (_b = getFilteredCohortsByCohortStatus(getFilteredCohorts(renderFilteredCohorts))) === null || _b === void 0 ? void 0 : _b.length, customText), _jsx("div", { className: "sr-only", id: "dialog-wrapper-bottom", tabIndex: 0 })] })));
}
